import { motion } from "framer-motion";
import SceneShell from "../components/SceneShell";
import MoneyFlow from "../components/MoneyFlow";

/**
 * Scene 43 — "20% uptake? £4–5 million annually."
 */

export default function Scene43_TwentyPercent() {
  return (
    <SceneShell variant="gold" align="center" data-testid="scene-20-percent">
      <MoneyFlow density={64} color="rgba(255,232,168,0.92)" symbol="£" />

      <motion.div
        className="absolute inset-0 pointer-events-none"
        animate={{
          background: [
            "radial-gradient(ellipse at center, rgba(255,232,168,0.36) 0%, transparent 55%)",
            "radial-gradient(ellipse at center, rgba(255,232,168,0.58) 0%, transparent 55%)",
            "radial-gradient(ellipse at center, rgba(255,232,168,0.36) 0%, transparent 55%)",
          ],
        }}
        transition={{ duration: 4, repeat: Infinity, ease: "easeInOut" }}
      />

      <div className="relative max-w-[1600px] mx-auto w-full text-center">
        <motion.h2
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.3 }}
          className="kn-display text-3xl sm:text-5xl lg:text-6xl"
          style={{ color: "#0d0d0f", fontWeight: 800 }}
        >
          And if uptake is{" "}
          <span style={{ color: "#7a3a05" }}>20%?</span>
        </motion.h2>

        <motion.div
          initial={{ opacity: 0, scale: 0.65, filter: "blur(28px)" }}
          animate={{ opacity: 1, scale: 1, filter: "blur(0px)" }}
          transition={{ duration: 1.6, delay: 1.0, ease: [0.16, 1, 0.3, 1] }}
          className="mt-8"
          data-testid="4-5m-number"
        >
          <div
            className="kn-display tnum leading-[0.85] flex items-center justify-center gap-4"
            style={{
              fontSize: "clamp(120px, 20vw, 320px)",
              color: "#0d0d0f",
              textShadow:
                "0 8px 80px rgba(0,0,0,0.35), 0 0 140px rgba(255,255,255,0.55)",
              whiteSpace: "nowrap",
              fontWeight: 900,
            }}
          >
            <span>£4–5M</span>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.0, delay: 2.4 }}
          className="mt-2 kn-display text-3xl sm:text-5xl lg:text-6xl"
          style={{ color: "#0d0d0f", fontWeight: 800 }}
        >
          annually.
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.0, delay: 3.0 }}
          className="mt-10 max-w-2xl mx-auto rounded-2xl px-8 py-5"
          style={{
            background: "rgba(0,0,0,0.78)",
            color: "rgba(255,255,255,0.95)",
          }}
        >
          <div
            className="text-[11px] tracking-[0.32em] uppercase mb-2"
            style={{ color: "rgba(255,232,168,0.85)" }}
          >
            And remember…
          </div>
          <div className="text-lg sm:text-2xl" style={{ fontWeight: 700 }}>
            That's just the{" "}
            <span style={{ color: "#e9a820" }}>subscription</span>.
          </div>
        </motion.div>
      </div>
    </SceneShell>
  );
}
